import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'

import { ModalUpdateTypeData, updateCancelModal, updateConfirmFlag, updateConfirmModal, updateIsOpened, updateType } from '@Root/slices/myhouse/modal'
import { RootState } from '@Root/slices'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'

export default function useModal() {
  const dispatch = useDispatch()
  const modal = useSelector((state: RootState) => state.myhouseModal)

  const open = useCallback(
    (type: MODAL_TYPE, optionalData?: Partial<ModalUpdateTypeData>) => {
      // optionalData 에는 추가로 필요한 값들이 들어갑니다.
      dispatch(updateType(Object.assign({}, { type: type }, optionalData) as ModalUpdateTypeData))
      dispatch(updateIsOpened(true))
    },
    [dispatch],
  )

  const close = useCallback(() => {
    dispatch(updateIsOpened(false))

    dispatch(updateType({ type: MODAL_TYPE.NONE } as ModalUpdateTypeData))
  }, [dispatch])

  const setConfirmFlag = useCallback(
    (flag: boolean) => {
      dispatch(updateConfirmFlag(flag))
    },
    [dispatch],
  )

  const setConfirmModal = useCallback(
    (modal: MODAL_TYPE) => {
      dispatch(updateConfirmModal(modal))
    },
    [dispatch],
  )

  const setCancelModal = useCallback(
    (modal: MODAL_TYPE) => {
      dispatch(updateCancelModal(modal))
    },
    [dispatch],
  )

  const clean = useCallback(() => {
    dispatch(updateConfirmFlag(false))
    dispatch(updateConfirmModal(MODAL_TYPE.NONE))
    dispatch(updateCancelModal(MODAL_TYPE.NONE))
    dispatch(updateIsOpened(false))
    dispatch(updateType({ type: MODAL_TYPE.NONE } as ModalUpdateTypeData))
  }, [dispatch])

  return { modal, open, close, setConfirmFlag, setConfirmModal, setCancelModal, clean }
}
